import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px;
  text-align: center;
`;

const IconContainer = styled.div`
  margin-bottom: 24px;
`;

const Heading = styled(T.Heading)`
  margin-bottom: 16px;
`;

export const ScanItemPromptLegacy: React.FC<{ title: string }> = ({ title }) => {
  return (
    <Root>
      <IconContainer>
        <Icon
          source={icons.barcodeViewfinder}
          size="medium"
          fill={color.text}
          width={64}
          height={64}
        />
      </IconContainer>
      <Heading level={2} variant="headline">
        {title}
      </Heading>
      <span>
        <FormattedMessage id="warehouse.common.search_by_name" />
      </span>
    </Root>
  );
};
